import { IconProps } from "./dto";

export function ControlManagementIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 20 18" fill="none">
            <path d="M18.3333 9H15L12.5 16.5L7.5 1.5L5 9H1.66667" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
